import {CalendarTodayOutlined} from '@mui/icons-material'
import {Box, Typography, Chip} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {KPIS_WIDGET_NAMESPACE} from '../consts'

export const PlantStatusCardHeader = () => {
  const {t} = useTranslation(KPIS_WIDGET_NAMESPACE)

  return (
    <Box display="flex">
      <Box flex={1}>
        <Typography variant="h3" mb={2}>
          {t('plantStatus.cardTitle')}
        </Typography>
      </Box>
      <Chip
        icon={<CalendarTodayOutlined />}
        label={t('label.yesterday')}
        size="small"
        sx={{mx: 1}}
      />
    </Box>
  )
}
